import { Delete } from 'components/elements/file/Delete';
import { Tooltip } from 'components/elements/Tooltip';
import { Col } from 'components/grid/Col';
import { Container } from 'components/grid/Container';
import { Row } from 'components/grid/Row';
import { Info } from 'components/icons/Info';
import { InfoChange } from 'components/person/InfoChange';
import { PasswordChange } from 'components/person/PasswordChange';
import { PersonAddress } from 'components/person/PersonAddress';
import { personStatus } from 'core/constants/personStatus';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { GlamboxSessionStore } from 'core/glambox/GlamboxSessionStore';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { FileHandler2 } from 'views/development/FileHandler2';
import Styles from 'views/pages/DadosPessoais.module.scss';

class DadosPessoais extends Component {
  constructor(props) {
    super(props);

    this.state = {
      partnerDocument: null,
    };
  }

  isGp = () => {
    let session = new GlamboxSessionStore();
    let isGp = session.get('isGlampartner');
    return isGp;
  };

  componentDidMount() {
    if (this.isGp()) {
      this.getId();
    }
  }

  getId = () => {
    if (!this.isGp()) return null;

    ExecuteRequest(
      GlamboxEndpoints.InfluencerDocument.get,
      null,
      'GET',
      { Authorization: this.props.token },
      null,
      response => {
        const { statusCode, result } = response;

        if (statusCode === 200) {
          this.setState({
            partnerDocument: result.document.imageUrl,
          });
        }
      }
    );
  };

  renderId = () => {
    const { partnerDocument } = this.state;
    if (!this.isGp()) return null;

    if (partnerDocument) {
      let document = [partnerDocument];

      return (
        <div className={Styles['doc']}>
          <h4> Cópia de Documento </h4>
          <p> Obs: Tire previamente a foto do seu RG/CPF ou CNH antes de realizar o upload!</p>
          <div className="text-center">
            <figure>
              <img src={partnerDocument} />
            </figure>
            <Delete
              files={document}
              deleteUrl={GlamboxEndpoints.InfluencerDocument.delete}
              headers={{
                Authorization: this.props.token,
              }}
              onDeleteFinish={this.finish}
            />
          </div>
        </div>
      );
    } else {
      const url = `${process.env.REACT_APP_GB_API_ROOT}${GlamboxEndpoints.InfluencerDocument.upload.url}`;

      return (
        <div className={'row'}>
          <div className={'col-md-6'}>
            <h4> Cópia de Documento </h4>
            <p> Documentos Válidos: RG/CPF/CNH </p>
            <p>
              {' '}
              Requisitos da imagem
              <Tooltip position={'right'} label={'Formato jpg ou png'}>
                <Info className="_infoButton" fill={'#747F8B'} size={'14px'} />
              </Tooltip>
            </p>
          </div>
          <div className={'col-md-6'}>
            <div className={Styles['upload']}>
              <FileHandler2
                token={this.props.token}
                uploadUrl={url}
                finish={this.finish}
              />
            </div>
          </div>
        </div>
      );
    }
  };

  finish = fileUploaded => {
    this.setState({
      partnerDocument: fileUploaded[0].imageUrl,
    });
  };

  render() {
    if (!this.isGp()) {
      return (
        <div className={'p-2 p-lg-5'}>
          <Helmet>
            <title>Minha Glambox : Dados Pessoais</title>
          </Helmet>

          <h1>Dados Pessoais</h1>

          <Container fluid>
            <Row>
              <Col xs={12} lg={6}>
                <h3 className={'display-3'}>Informações Pessoais</h3>
                <InfoChange></InfoChange>
              </Col>
              <Col xs={12} lg={6}>
                <h3 className={'display-3'}>Alterar Senha</h3>
                <PasswordChange></PasswordChange>
              </Col>
              {(() => {
                if (
                  this.props.subscribers?.length > 0 ||
                  this.props.person.personStatus === personStatus.Glampartner
                ) {
                  return (
                    <Col xs={12} lg={6}>
                      <h3 className={'display-3'}>Alterar Endereço</h3>
                      <PersonAddress
                        subscriberId={this.props.subscribers[0] || null}
                      ></PersonAddress>
                    </Col>
                  );
                }
              })()}
            </Row>
          </Container>
        </div>
      );
    }

    const { history, match } = this.props;

    return (
      <div className={'p-2 p-lg-5'}>
        <Helmet>
          <title>Minha Glambox : Meus Dados</title>
        </Helmet>

        <h1>Meus Dados</h1>

        <Container fluid>
          <Row>
            <Col xs={12} lg={6}>
              <h3 className={'display-3'}>Informações Pessoais</h3>
              <InfoChange></InfoChange>

              <div className={'gb-contentblock p-3 p-lg-4 level-2 mb-2 '}>
                <div className={Styles['files']}>{this.renderId()}</div>
              </div>
            </Col>

            <Col className={'mb-2'} xs={12} lg={6}>
              <h3 className={'display-3'}>Alterar Senha</h3>
              <PasswordChange></PasswordChange>
            </Col>
            {(() => {
              if (
                this.props.subscribers?.length > 0 ||
                this.props.person.personStatus === personStatus.Glampartner
              ) {
                return (
                  <Col xs={12} lg={6}>
                    <h3 className={'display-3'}>Alterar Endereço</h3>
                    <PersonAddress
                      subscriberId={this.props.subscribers[0] || null}
                    ></PersonAddress>
                  </Col>
                );
              }
            })()}
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    person: state.person.data.person,
    subscribers: state.subscribers.data,
    partnerGeneral: state.partnerGeneral.data,
    partnerInfo: state.partnerInfo.data,
    token: state.token.data.Authorization,
  };
};

const mapDispatchToProps = dispatch => ({});

DadosPessoais = connect(mapStateToProps, mapDispatchToProps)(DadosPessoais);

export { DadosPessoais };
